<script>
  import tippy from 'tippy.js';
  import WelcomeNoteModal from './modal/WelcomeNoteModal.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');

  import { getProfileStore } from '@stores/profile';
  let groupsStore = getProfileStore('groupsStore');

  import { onMount } from 'svelte';

  export let tooltipMessageContent = 'Welcome note is active';
  export let location;
  export let groupId;
  export let mobile = false;

  let group;
  let currentUser = getCurrentUserStore('default');
  let showWelcomeNoteModal = false;
  let welcomeNoteEditMode = false;

  let setupTippy = (node, data) => {
    if (mobile) {
      return;
    }

    let instance = tippy(node, {
      content: data,
    });

    return {
      destroy() {
        try {
          instance.destroy();
        } catch {}
      },
    };
  };

  let showWelcomeNote = function (edit) {
    showWelcomeNoteModal = true;

    if (!mobile) {
      welcomeNoteEditMode = edit;
    }
  };

  onMount(() => {
    group = groupId ? groupsStore.find(groupId) : groupStore;
    let unsubGroup = group.subscribe((x) => (group = x));

    return () => {
      unsubGroup();
    };
  });
</script>

<style style="text/scss" lang="scss">
  // @todo scope new changes to a flag to be used on new tile

  .welcome-active {
    margin-right: 16px;
    cursor: pointer;

    &.profile-cover-photos {
      padding-top: 10px;

      &.mobile {
        padding-top: 9px;
        margin-right: 8px;
      }
      > a > img {
        height: 20px;
      }
    }

    &.profile-new {
      padding-top: 14px;
      &.mobile {
        padding-top: 12px;
        margin-right: 8px;
      }
      > a > img {
        height: 20px;
      }
    }
    &.profile {
      padding-top: 9px;
      &.mobile {
        padding-top: 10px;
        margin-right: 8px;
      }
      > a > img {
        height: 18px;
      }
    }
  }
</style>

{#if group && group.permissions.edit && group.welcome_note_enabled}
  <div
    class="welcome-active"
    class:profile={location === 'profile'}
    class:profile-new={location === 'profileNew'}
    class:profile-cover-photos={location === 'profileCoverPhotos'}
    class:mobile={mobile}
    use:setupTippy={tooltipMessageContent}>
    {#if showWelcomeNoteModal}
      <WelcomeNoteModal
        group={group}
        mobile={mobile}
        currentUser={currentUser}
        on:close={() => {
          showWelcomeNoteModal = false;
        }}
        bind:edit={welcomeNoteEditMode} />
    {/if}
    <a
      href="#"
      on:click|preventDefault|stopPropagation={() => {
        showWelcomeNote(false);
      }}
      class="welcome-note-modal-link">
      <img src="/images/welcome-active/welcome-active.svg" />
    </a>
  </div>
{/if}
